import { METATAGGER_AUDIT_ACTIONS } from 'ion-experimental/app/metatagger/auditActions';

// MetaTagger's actions, maintained in ion-experimental. None identifies a record Ion can scope to
// yet: entity: null, renderMode: 'keyValue', and no predecessor lookup.
const ACTIONS = Object.values(METATAGGER_AUDIT_ACTIONS);

export const metataggerEntries = Object.fromEntries(
  ACTIONS.map(action => [action, { entity: null, identity: 'event', renderMode: 'keyValue', createsRecord: false }])
);

const containerId = 'e7e7f8f8-0000-4a11-9e33-5c0a1a111111';

export const metataggerFixtures = Object.fromEntries(
  ACTIONS.map(action => [action, { action, debugData: { containerId } }])
);
